import { AxiosResponse } from "axios";
import Api from "./Api";

class CurrencyConversionApi {
  constructor(private api: Api) {}

  public uploadExchangeRates(
    year: number,
    payload: FormData,
    progressCallback?: (progressEvent: { loaded: number; total: number }) => void,
  ): Promise<AxiosResponse<Record<string, number>>> {
    const file = payload.get("file");
    if (!payload.get("filename") && file && typeof file === "object" && file.name) {
      payload.append("filename", file.name.normalize());
    }
    return this.api.post(`/test-request/v2/currency-conversion/${encodeURIComponent(year)}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: progressCallback,
    });
  }
}

export default CurrencyConversionApi;
